import { render, staticRenderFns } from "./CreateDepartmentRule.vue?vue&type=template&id=098276f3"
import script from "./CreateDepartmentRule.vue?vue&type=script&lang=js"
export * from "./CreateDepartmentRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports